import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

/**
 * OpponentScores Component
 * Displays live scores of other players during gameplay
 *
 * @param {object} allPlayerLiveScores - Object with player names as keys and score breakdowns as values
 * @param {string} currentPlayerName - Name of the current player (to exclude from display)
 */
const OpponentScores = ({ allPlayerLiveScores, currentPlayerName }) => {
  const { t } = useLanguage();

  // Filter out the current player and get list of opponents
  const opponents = Object.entries(allPlayerLiveScores)
    .filter(([name]) => name !== currentPlayerName);

  // Don't render if no opponents
  if (opponents.length === 0) return null;

  return (
    <div className="opponent-scores-display">
      <h3>📊 {t('liveScore.otherPlayersScores')}</h3>
      <table className="opponent-scores-table">
        <thead>
          <tr>
            <th className="player-column">{t('liveScore.player')}</th>
            <th className="red-column">{t('colors.red')}</th>
            <th className="yellow-column">{t('colors.yellow')}</th>
            <th className="green-column">{t('colors.green')}</th>
            <th className="blue-column">{t('colors.blue')}</th>
            <th className="penalty-column">{t('penalties.label')}</th>
            <th className="total-column">{t('gameOver.total')}</th>
          </tr>
        </thead>
        <tbody>
          {opponents.map(([playerName, scores]) => (
            <tr key={playerName}>
              <td className="player-column">{playerName}</td>
              <td className="red-column">{scores.red || 0}</td>
              <td className="yellow-column">{scores.yellow || 0}</td>
              <td className="green-column">{scores.green || 0}</td>
              <td className="blue-column">{scores.blue || 0}</td>
              <td className="penalty-column">{scores.penalties || 0}</td>
              <td className="total-column"><strong>{scores.total || 0}</strong></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default OpponentScores;
